import type { ArtWork } from "../types/ArtWork";
import { artWorks } from "./data";
import type { DigitalCollectionId } from "./digitalArtworkCatalog";
import {
  digitalArtworkAssets,
  digitalArtworkImageUrl,
} from "./digitalArtworkAssets";

export type DigitalArtwork = ArtWork & {
  collection: DigitalCollectionId;
};

export const digitalArtworks: DigitalArtwork[] = artWorks.map((work) => {
  const asset = digitalArtworkAssets[work.id];
  if (!asset) {
    throw new Error(`Missing digital artwork asset mapping for id: ${work.id}`);
  }
  return {
    ...work,
    collection: asset.collection,
    imageUrl: digitalArtworkImageUrl(asset.collection, asset.imageFile),
  };
});

export function digitalArtworkById(id: string): DigitalArtwork | undefined {
  return digitalArtworks.find((work) => work.id === id);
}
